// Loads the soundboard list in priority order:
// 1. Lambda Function URL (real-time scrape of rm-brown-soundboard.com)
// 2. locally scraped JSON (npm run scrape-soundboard)
// 3. committed static JSON
// so a failed layer never breaks the page.
const LAMBDA = 'https://sll64v2ving6lfubnivrviky6q0kpynn.lambda-url.eu-west-1.on.aws/';
const LIVE = '/rmbrown-soundboard-live.json';
const FALLBACK = '/rmbrown-soundboard.json';

export default async function loadSoundboardData() {
  for (const url of [LAMBDA, LIVE, FALLBACK]) {
    try {
      const response = await fetch(url, { signal: AbortSignal.timeout(15000) });
      if (!response.ok) continue;
      const data = await response.json();
      if (Array.isArray(data) && data.length) {
        if (url !== LAMBDA) console.warn('Soundboard: fallback list in use, lambda unavailable');
        return data;
      }
    } catch (e) { /* try next */ }
  }
  throw new Error('No soundboard list available (live or fallback)');
}
